import {
	type OrderSetupDetailResponseDto,
	type OrderSetupUpdateDto,
	putOrderSetupId,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { ORDER_SETUP_ID } from "Settings/Modules/OrderSetup/Api/Query/useOrderSetupIdQuery";
import { getOrderSetupKey } from "Settings/Modules/OrderSetup/Api/Query/useOrderSetupListQuery";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const mutationResource = Resources.base.orderSetup.mutation;

export const useUpdateOrderSetupMutation = (orderSetupId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: OrderSetupUpdateDto) =>
			putOrderSetupId(data, orderSetupId),
		),
		onError: (error) => {
			toast.error(`${t(mutationResource.updateOrderSetupError)}`);
			console.error(`${t(mutationResource.updateOrderSetupError)}`, error);
		},
		onSuccess: (data) => {
			const orderSetup = !!data
				? (data as OrderSetupDetailResponseDto)
				: undefined;

			toast.success(`${t(mutationResource.updateOrderSetupSuccess)}`);
			queryClient.invalidateQueries({ queryKey: [ORDER_SETUP_ID] });

			if (!orderSetup) {
				return;
			}

			queryClient.invalidateQueries({
				queryKey: getOrderSetupKey(
					orderSetup.market.id,
					orderSetup.vertical.id,
				),
			});
		},
	});
};
